import { Route, Routes } from "react-router-dom";
import { OSCI0501001Q } from "@/tz/go/egaz/osci/ststcl/ptl/OSCI0501001Q";
import { OSCI0501002Q } from "@/tz/go/egaz/osci/ststcl/ptl/OSCI0501002Q";
import { OSCI0502001Q } from "../lpco/OSCI0502001Q";
import { OSCI0502002Q } from "../lpco/OSCI0502002Q";
import { OSCI0502003Q } from "../lpco/OSCI0502003Q";
import { OSCI0502004Q } from "../lpco/OSCI0502004Q";
import { OSCI0502005Q } from "../lpco/OSCI0502005Q";
import { OSCI0502006Q } from "../lpco/OSCI0502006Q";
import { OSCI0502007Q } from "../lpco/OSCI0502007Q";
import { OSCI0502008Q } from "../lpco/OSCI0502008Q";
import { OSCI0502009Q } from "../lpco/OSCI0502009Q";
import { OSCI0502010Q } from "../lpco/OSCI0502010Q";

/*
 * 응용기능별 Router
 * - 명명규칙 : 응용기능 2 레벨 메타 단어(용어) 카멜표기(첫글자 대문자) + Router
 * - 응용기능 2 레벨 별로 Router 분리 원칙(기본)
 * - 응용기능 레벨별로 소문자로 구분하여 경로 작성
 * - 최종 라우팅하는 주소는 화면 아이디에서 '-' 구분자를 빼고 소문자로 변환하여 작성
 * - element 에 해당 화면 컴포넌트 기입
 * - 화면에서 파라메터로 받아서 사용할 키값은 path 문자열에 ':변수명' 으로 기입하여 해당 컴포넌트 인지하여 사용
 * TODO URL의 'key' 를 실제 ID로 변경 하세요.
 * TODO 위의 한글 주석은 마지막에 전부 삭제하세요.
 */

export const OsciStstclRouter = () => {
    return (
        <Routes>
            {/** ==================== 접속 통계 ==================== */}
            <Route path="/ptl/osci0501001q" element={<OSCI0501001Q />} />
            <Route path="/ptl/osci0501002q/:acssDt/:acssMenuId" element={<OSCI0501002Q />} />

            {/** ==================== 통계 ==================== */}
            <Route path="osci0502001q" element={<OSCI0502001Q />} />
            <Route path="osci0502002q" element={<OSCI0502002Q />} />
            <Route path="osci0502003q" element={<OSCI0502003Q />} />
            <Route path="osci0502004q" element={<OSCI0502004Q />} />
            <Route path="osci0502005q" element={<OSCI0502005Q />} />
            <Route path="osci0502006q" element={<OSCI0502006Q />} />
            <Route path="osci0502007q" element={<OSCI0502007Q />} />
            <Route path="osci0502008q" element={<OSCI0502008Q />} />
            <Route path="osci0502009q" element={<OSCI0502009Q />} />
            <Route path="osci0502010q" element={<OSCI0502010Q />} />
        </Routes>
    );
};
